// extracted by mini-css-extract-plugin
export var md = "_27-4";
export var semantic = "_27-5";
export var sm = "_27-3";
export var text = "_27-6";
export var toggleInput = "_27-0";
export var toggleSwitch = "_27-1";
export var xs = "_27-2";